module.exports = __webpack_public_path__ + "media/functional__son.5b1b3697.mp4";